import React from "react";
import {
  McqList,
  McqItem,
  McqLabel,
  McqContent,
  McqAssetImage,
  McqText,
  McqRadio
} from "./session-card.styles";
import { PracticeAnswer } from "services/api/practice/practiceService.types";

interface McqOptionsProps {
  answerList: PracticeAnswer[];
  selectedAnswer: string | null;
  onSelect?: (id: string) => void;
  onImagePress?: (url: string) => void;
  selectedAnswerCorrect?: boolean;
  readOnly?: boolean;
}

export const MCQOptions: React.FC<McqOptionsProps> = ({
  answerList,
  selectedAnswer,
  onSelect,
  onImagePress,
  selectedAnswerCorrect,
  readOnly = false
}) => {
  return (
    <McqList role="radiogroup" aria-label="Pilihan jawaban">
      {answerList.map((answer, index) => {
        const selectedAns = selectedAnswer === answer.id;
        const status = selectedAns
          ? selectedAnswerCorrect === undefined
            ? "selected"
            : selectedAnswerCorrect
              ? "correct"
              : "incorrect"
          : "default";
        return (
          <McqItem
            key={answer.id}
            role="radio"
            aria-checked={selectedAns}
            $selected={selectedAns}
            $status={status}
            disabled={readOnly}
            onClick={() => onSelect?.(answer.id)}
          >
            <McqLabel $selected={selectedAns} $status={status}>
              {String.fromCharCode(65 + index)}
            </McqLabel>
            <McqContent>
              {(answer.assets ?? []).map((asset, assetIndex) => (
                <McqAssetImage
                  key={`${answer.id}-asset-${assetIndex}`}
                  src={asset}
                  alt={`Gambar pilihan ${String.fromCharCode(65 + index)}`}
                  role={onImagePress ? "button" : undefined}
                  tabIndex={onImagePress ? 0 : undefined}
                  onClick={(event: React.MouseEvent<HTMLImageElement>) => {
                    event.stopPropagation();
                    onImagePress?.(asset);
                  }}
                  onKeyDown={(event: React.KeyboardEvent<HTMLImageElement>) => {
                    if (!onImagePress) return;
                    if (event.key !== "Enter" && event.key !== " ") return;

                    event.preventDefault();
                    event.stopPropagation();
                    onImagePress(asset);
                  }}
                />
              ))}
              <McqText $selected={selectedAns} $status={status}>
                {answer.title}
              </McqText>
            </McqContent>
            <McqRadio $selected={selectedAns} $status={status} />
          </McqItem>
        );
      })}
    </McqList>
  );
};
